module.exports = __webpack_public_path__ + "img/cloud-upload-outline.3d3a9e74.svg";